import { render, staticRenderFns } from "./GlobalSlogan.vue?vue&type=template&id=37b94472&scoped=true&name=global-slogan&"
import script from "./GlobalSlogan.vue?vue&type=script&lang=js&"
export * from "./GlobalSlogan.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSlogan.vue?vue&type=style&index=0&id=37b94472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b94472",
  null
  
)

export default component.exports